var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 10.875,
    stroke: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2025 13.9935C18.5736 14.2292 18.5736 14.7708 18.2025 15.0065L12.4217 18.6778C12.0222 18.9315 11.5 18.6445 11.5 18.1713V10.8287C11.5 10.3555 12.0222 10.0685 12.4217 10.3222L18.2025 13.9935Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroom);
export default __webpack_public_path__ + "static/media/classroom.7cc39be4b2c6efc9569d989abda31a0f.svg";
export { ForwardRef as ReactComponent };